import { FC } from "react";
import { Table } from "antd";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

interface ColumnConfig {
  title: string;
  key: string;
  dataIndex?: string;
  width?: number | string;
}

interface CommonPopupTableViewProps {
  data: any[];
  columns: ColumnConfig[];
  className?: string;
  rowKey?: string;
  scroll?: { x?: string | true };
  loading: boolean,
  pageSize?: number;
  showPagination?: boolean;
}

const CommonPopupTableView: FC<CommonPopupTableViewProps> = ({
  data,
  columns,
  className = "popup-table",
  rowKey = "id",
  scroll,
  loading = false,
  pageSize = 5,
  showPagination = true
}) => {
  const mappedColumns = columns.map(col => ({
    title: col.title,
    dataIndex: col.dataIndex || col.key,
    key: col.key,
    width: col.width
  }));

  return (
    <Table
      dataSource={data}
      columns={mappedColumns}
      rowKey={rowKey}
      className={className}
      size="middle"
      pagination={
        showPagination
          ? {
              pageSize,
              showSizeChanger: false,
              size: "default"
            }
          : false
      }
      scroll={scroll}
      loading={{ spinning: loading, indicator: <HealthemSpinner /> }}
    />
  );
};

export default CommonPopupTableView;
